import gql from 'graphql-tag';

export const ATTACHMENT_FRAGMENT = gql`
  fragment AttachmentFragment on Attachment {
    id
    job_id
    account_id
    creator_user_id
    creatorFullName
    client_account_id
    service_item_id
    estimate_id
    property_id
    note_id
    message_id
    invoice_id
    fileName
    fileSize
    mimeType
    base64
    isInternal
    type
    createdAt
    updatedAt
  }
`;
